module.exports = __webpack_public_path__ + "img/chat-user.61e94467.png";